import classNames from 'classnames';
import { stringify } from 'qs';
import { Link } from 'react-router-dom';
import { LeaderboardGroup } from '~/components/Challenge/Leaderboard/ChallengeLeaderboard.hooks';
import { T } from '~/components/I18n';
import { Tabs } from '~/components/Tab/Tabs';
import styles from './ChallengeLeaderboardTabs.module.scss';

export type ChallengeLeaderboardTabsProps = {
  value: LeaderboardGroup;
  scored: boolean;
  eventId: number;
  className?: string;
};
export const ChallengeLeaderboardTabs = ({
  value,
  scored,
  eventId,
  className,
}: ChallengeLeaderboardTabsProps) => (
  <Tabs className={classNames(styles.root, className)}>
    {scored && (
      <li>
        <Link
          to={{ search: stringify({ eventId, group: 'RIVAL_GROUP' }, { addQueryPrefix: true }) }}
          className={classNames(styles.tab, {
            [styles.active]: value === 'RIVAL_GROUP',
          })}
          replace>
          <T name="citizen_challenge_ranking_rival" />
        </Link>
      </li>
    )}

    <li>
      <Link
        to={{ search: stringify({ eventId, group: 'TOP' }, { addQueryPrefix: true }) }}
        className={classNames(styles.tab, {
          [styles.active]: value === 'TOP',
        })}
        replace>
        <T name="citizen_challenge_ranking_top50" />
      </Link>
    </li>
  </Tabs>
);
